const FORCE_SUBMIT_SELECTOR = ".button.button--xl[is='custom-button'].force-submit";

function forceSubmit(event) {
  if (typeof this._onSubmit === 'function') {
    this._onSubmit(event);
    return;
  }
}

function checkSelectedBar(eventFromApp) {
  const target = eventFromApp.target;
  const dealBarId = eventFromApp.detail?.dealBarId;
  if (!(target instanceof HTMLElement)) {
    console.error('[Kaching Bundles] deal-bar-selected: event target is not a valid HTMLElement.');
    return;
  }
  const variantPicker = target.closest("[data-block-type='variant-picker']");
  if (!variantPicker) {
    console.error('[Kaching Bundles] deal-bar-selected: variant picker container was not found.');
    return;
  }

  const inputOneTime = variantPicker.querySelector('.subsription-widget__field--one-time input');
  const accordion = variantPicker.querySelector('.accordion-toggle-item');
  if (!inputOneTime || !accordion) {
    console.error('[Kaching Bundles] deal-bar-selected: required one-time input or accordion element is missing.');
    return;
  }

  if (dealBarId) {
    accordion.removeAttribute('open');
    const label = inputOneTime.labels[0];
    if (label) {
      label.click();
    } else {
      inputOneTime.checked = true;
    }
  }
}

function changeManualQuantity(eventFromApp) {
  const { variantIdQuantities } = eventFromApp.detail;
  const quantity = variantIdQuantities.map((variant) => variant.quantity).reduce((a, b) => a + b, 0) || 1;
  const mainForm = getMainForm(eventFromApp);

  if (mainForm && mainForm['quantity']) {
    const formFields = [...mainForm['quantity']];
    formFields.forEach((field) => field.setAttribute('value', quantity));
  }
}

function changeManualSellingPlan(event) {
  const selectedDealBarId = event.target.selectedDealBarId;
  const mainForm = getMainForm(event);

  if (!mainForm && !mainForm.selling_plan) {
    const formFields = [...mainForm['selling_plan']];
    formFields.forEach((field) => field.toggleAttribute('disabled', Boolean(selectedDealBarId)));
  }
}

function changeManualPrice(event) {
  const isSelectedApp = Boolean(event.target.selectedDealBarId);
  if (!isSelectedApp) return;

  const { discountedPrice, fullPrice } = event.detail?.pricing;

  const amountDiscountedPrice = discountedPrice.amount;
  const amountfullPrice = fullPrice.amount;

  const shopifyFormat = themeVariables.settings.moneyFormatString;
  const shopifyFormatMoney = themeVariables.utils.money;

  const kachingAppPrice = document.querySelector('.kaching-app-price');
  const originPrice = document.querySelector('.product-info__block-item .origin-price');
  const comparePrice = document.querySelector('.product-info__block-item compare-at-price');
  const buttonsPrice = document.querySelectorAll('.product .button-product-price');
  const saveBadge = document.querySelector('.price-save-badge');
  const saveBadgeText = saveBadge?.querySelector('.price-save-badge span');

  const shouldHide = amountDiscountedPrice === amountfullPrice;
  if (saveBadge) saveBadge.toggleAttribute('hidden', shouldHide);
  if (comparePrice) comparePrice.toggleAttribute('hidden', shouldHide);

  const changePrice = () => {
    if (amountDiscountedPrice) {
      const moneyPrice = shopifyFormatMoney(amountDiscountedPrice, shopifyFormat);
      if (originPrice) originPrice.textContent = moneyPrice;
      buttonsPrice.forEach((buttonPrice) => (buttonPrice.textContent = `- ${moneyPrice}`));
    }
    if (amountfullPrice) {
      const moneyPrice = shopifyFormatMoney(amountfullPrice, shopifyFormat);
      if (comparePrice) comparePrice.textContent = moneyPrice;
    }

    if (saveBadgeText && amountfullPrice && amountDiscountedPrice) {
      const { placeholderText, textType } = saveBadgeText.dataset;

      let currentSaveValue = null;

      if (textType === 'percent') {
        const percent = Math.round(((amountfullPrice - amountDiscountedPrice) * 100) / amountfullPrice);
        currentSaveValue = percent > 0 ? `${percent}%` : null;
      } else {
        const saveAmount = amountfullPrice - amountDiscountedPrice;
        currentSaveValue = saveAmount > 0 ? moneyFormatter(saveAmount, shopifyFormat) : null;
      }

      saveBadgeText.textContent = placeholderText.replace('[]', currentSaveValue);
    }

    if (kachingAppPrice) {
      kachingAppPrice.innerHTML = kachingAppPrice.textContent;
    }
  };

  schedulePriceLoad(changePrice);
}

const schedulePriceLoad = (callback) => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 1000 });
    return;
  }

  window.setTimeout(callback, 1000);
};

function handleToggleTypeButton(event) {
  const isSelectedApp = Boolean(event.target.selectedDealBarId);
  const mainForm = getMainForm(event);

  if (!mainForm) return;

  const button = mainForm.querySelector(".button.button--xl[is='custom-button']");
  if (!button) {
    console.error('[Kaching Bundles] Submit button not found');
    return;
  }

  button.setAttribute('type', isSelectedApp ? 'submit' : 'button');
  button.classList.toggle('force-submit', !isSelectedApp);
}

function getMainForm(event) {
  const bundleInner = event.target.closest('.kaching-bundle__inner');
  if (!bundleInner) {
    console.error('[Kaching Bundles] Bundle inner not found');
    return null;
  }

  const formId = bundleInner.dataset.formId;
  const mainForm = document.getElementById(formId);

  return mainForm ?? null;
}

function handleVariantsChanged(event) {
  changeManualQuantity(event);
  changeManualSellingPlan(event);
  handleToggleTypeButton(event);
  changeManualPrice(event);
}

function interceptForceSubmitClick(event) {
  const target = event.target;

  if (!(target instanceof Element)) return;

  const button = target.closest(FORCE_SUBMIT_SELECTOR);
  if (!button) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const form = button.form || button.closest('form');
  if (!form) {
    console.error('[Kaching Bundles] Form not found for force-submit button');
    return;
  }

  forceSubmit.call(form, event);
}

function appendPrice(container, text, includeExtraText) {
  if (!container || !text) return;

  const appendElement = container.querySelector('span.price-append');
  let priceContainer = null;

  if (appendElement) {
    appendElement.textContent = text;
    priceContainer = appendElement;
  } else {
    const span = document.createElement('span');
    span.classList.add('price-append');
    span.textContent = text;
    container.prepend(span);
    priceContainer = span;
  }

  if (includeExtraText === true && priceContainer) {
    const small = document.createElement('small');
    small.textContent = 'Per set';
    priceContainer.appendChild(small);
  }
}

function updateBlockPrices(block) {
  const shopifyFormat = themeVariables.settings.moneyFormatString;
  const shopifyFormatMoney = themeVariables.utils.money;

  const getJsonAttribute = (attribute) => {
    try {
      return JSON.parse(block.getAttribute(attribute));
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const dealBlock = block.dealBlock || getJsonAttribute('deal-block');
  const config = block.config || getJsonAttribute('config');

  if (!dealBlock || !config) return;

  const cleanupAppendedPrice = (container) => {
    const appendedPrice = container?.querySelector('span.price-append');
    if (appendedPrice) appendedPrice.remove();
  };

  const getDealBarQuantity = (dealBar) => {
    if (!dealBar) return 1;
    if (dealBar.dealBarType === 'bxgy') return Number(dealBar.buyQuantity || 0) + Number(dealBar.getQuantity || 0) || 1;
    return Number(dealBar.quantity) || 1;
  };

  const getVariantPrice = (variant, sellingPlan) => {
    if (!variant) return 0;
    if (!sellingPlan) return Number(variant.price) || 0;

    const sellingPlanPrice = variant.sellingPlans?.find((plan) => plan.id === sellingPlan.id)?.price;
    return Number(sellingPlanPrice ?? variant.price) || 0;
  };

  const getFullVariantPrice = (dealBar, variant) => {
    if (!variant) return 0;

    let fullPrice = Number(variant.price) || 0;
    const shouldUseCompareAtPrice =
      Boolean(dealBlock.useProductCompareAtPrice) ||
      ((!dealBar.dealBarType || dealBar.dealBarType === 'quantity-break') && dealBar.discountType === 'default');

    if (shouldUseCompareAtPrice && variant.compareAtPrice) {
      fullPrice = Math.max(fullPrice, Number(variant.compareAtPrice) || 0);
    }

    return fullPrice;
  };

  const applySellingPlanPriceAdjustment = (price, sellingPlan) => {
    const priceAdjustment = sellingPlan?.priceAdjustment;
    if (!priceAdjustment) return price;

    switch (priceAdjustment.type) {
      case 'percentage':
        return price * (1 - priceAdjustment.value / 100);
      case 'fixed_amount':
        return price - priceAdjustment.value;
      case 'price':
        return priceAdjustment.value;
      default:
        return price;
    }
  };

  const calculateDiscountedTotal = ({ dealBar, variant, quantity, currencyRate = 1, sellingPlan = null }) => {
    const basePrice = getVariantPrice(variant, sellingPlan);
    const fullOrderPrice = basePrice * quantity;

    if (dealBar.dealBarType === 'bxgy') {
      const getQuantity = Math.min(quantity, Number(dealBar.getQuantity || 0));
      const buyQuantity = Math.max(0, quantity - getQuantity);

      const calculateDiscountedPart = (discountType, discountValue, discountQuantity) => {
        if (discountQuantity <= 0) return 0;

        if (discountType === 'specific') {
          let totalSpecificPrice = 100 * Number(discountValue || 0) * currencyRate;
          if (discountQuantity > Number(dealBar.quantity || discountQuantity)) {
            const pricePerItem = totalSpecificPrice / Number(dealBar.quantity || discountQuantity);
            totalSpecificPrice = Math.ceil(pricePerItem * discountQuantity);
          }

          const specificPricePerItem = totalSpecificPrice / discountQuantity;
          const adjustedPricePerItem =
            sellingPlan &&
            variant.sellingPlans?.some((plan) => plan.id === sellingPlan.id) &&
            sellingPlan.priceAdjustment
              ? applySellingPlanPriceAdjustment(specificPricePerItem, sellingPlan)
              : specificPricePerItem;

          return Math.max(0, Math.min(adjustedPricePerItem * discountQuantity, basePrice * discountQuantity));
        }

        if (discountType === 'percentage') {
          return Math.max(
            0,
            Math.min(
              Math.ceil((basePrice * (100 - Number(discountValue || 0))) / 100) * discountQuantity,
              basePrice * discountQuantity,
            ),
          );
        }

        if (discountType === 'amount') {
          const amountOffPerItem = Math.round(100 * Number(discountValue || 0)) * currencyRate;
          return Math.max(0, Math.min((basePrice - amountOffPerItem) * discountQuantity, basePrice * discountQuantity));
        }

        return basePrice * discountQuantity;
      };

      return (
        calculateDiscountedPart(
          dealBar.getDiscountType || 'percentage',
          dealBar.getDiscountValue || '100',
          getQuantity,
        ) + calculateDiscountedPart(dealBar.buyDiscountType || 'default', dealBar.buyDiscountValue || '0', buyQuantity)
      );
    }

    if (dealBar.discountType === 'specific') {
      let totalSpecificPrice = 100 * Number(dealBar.discountValue || 0) * currencyRate;
      const configuredQuantity = Number(dealBar.quantity || quantity) || quantity;

      if (quantity > configuredQuantity) {
        const pricePerItem = totalSpecificPrice / configuredQuantity;
        totalSpecificPrice = Math.ceil(pricePerItem * quantity);
      }

      const specificPricePerItem = totalSpecificPrice / quantity;
      const adjustedPricePerItem =
        sellingPlan && variant.sellingPlans?.some((plan) => plan.id === sellingPlan.id) && sellingPlan.priceAdjustment
          ? applySellingPlanPriceAdjustment(specificPricePerItem, sellingPlan)
          : specificPricePerItem;

      return Math.max(0, Math.min(adjustedPricePerItem * quantity, fullOrderPrice));
    }

    if (dealBar.discountType === 'percentage') {
      return Math.max(
        0,
        Math.min(Math.ceil((basePrice * (100 - Number(dealBar.discountValue || 0))) / 100) * quantity, fullOrderPrice),
      );
    }

    if (dealBar.discountType === 'amount') {
      const amountOffPerItem = Math.round(100 * Number(dealBar.discountValue || 0)) * currencyRate;
      return Math.max(0, Math.min(fullOrderPrice - amountOffPerItem * quantity, fullOrderPrice));
    }

    return fullOrderPrice;
  };

  const product = block.product || getJsonAttribute('product');
  if (!product?.variants?.length || !Array.isArray(dealBlock.dealBars)) return;

  const currentVariantId = block.currentVariantId;
  const currentSellingPlanId = block.sellingPlanId;
  const selectedDealBarId = block.selectedDealBarId;
  const customQuantity = Number(block.quantity) || null;

  const getVariantForDealBar = (dealBar) => {
    const defaultVariantIds = dealBlock.defaultVariantsV2
      ?.find((item) => item.dealBarId === dealBar.id && String(item.productGID).split('/').pop() === String(product.id))
      ?.variantGIDs?.map((id) => Number(String(id).split('/').pop()))
      ?.filter(Boolean);

    if (Array.isArray(defaultVariantIds) && defaultVariantIds.length > 0) {
      return product.variants.find((variant) => variant.id === defaultVariantIds[0]) || product.variants[0];
    }

    return product.variants.find((variant) => variant.id === currentVariantId) || product.variants[0];
  };

  const getSellingPlanForDealBar = (dealBar, variant) => {
    if (!variant?.sellingPlans?.length) return null;

    const matchedCurrentSellingPlan = currentSellingPlanId
      ? product.sellingPlans?.find((plan) => plan.id === currentSellingPlanId)
      : null;

    if (dealBar.sellingPlanEnabled) {
      const configuredSellingPlanId = dealBar.sellingPlanGid
        ? Number(String(dealBar.sellingPlanGid).split('/').pop())
        : null;
      const configuredSellingPlan = configuredSellingPlanId
        ? product.sellingPlans?.find((plan) => plan.id === configuredSellingPlanId)
        : null;
      const fallbackSellingPlan =
        matchedCurrentSellingPlan || configuredSellingPlan || product.sellingPlans?.[0] || null;

      if (fallbackSellingPlan && variant.sellingPlans.some((plan) => plan.id === fallbackSellingPlan.id)) {
        return fallbackSellingPlan;
      }

      return (
        product.sellingPlans?.find((plan) => variant.sellingPlans.some((variantPlan) => variantPlan.id === plan.id)) ||
        null
      );
    }

    if (matchedCurrentSellingPlan && variant.sellingPlans.some((plan) => plan.id === matchedCurrentSellingPlan.id)) {
      return matchedCurrentSellingPlan;
    }

    if (product.requiresSellingPlan) {
      return (
        product.sellingPlans?.find((plan) => variant.sellingPlans.some((variantPlan) => variantPlan.id === plan.id)) ||
        null
      );
    }

    return null;
  };

  const pricing = {
    discountedPrice: {
      amount: 1999,
      formatted: '$19.99',
    },
    fullPrice: {
      amount: 2499,
      formatted: '$24.99',
    },
  };

  dealBlock.dealBars.forEach((dealBar) => {
    const selector = block.querySelector(`[data-deal-bar-id='${dealBar.id}']`);
    if (!selector) return;

    const variant = getVariantForDealBar(dealBar);
    if (!variant) return;

    const quantity = selectedDealBarId === dealBar.id && customQuantity ? customQuantity : getDealBarQuantity(dealBar);
    const sellingPlan = getSellingPlanForDealBar(dealBar, variant);
    const fullTotal = getFullVariantPrice(dealBar, variant) * quantity;
    const discountedTotal = calculateDiscountedTotal({
      dealBar,
      variant,
      quantity,
      currencyRate: Number(config.currencyRate) || 1,
      sellingPlan,
    });

    // const discountPrice = selector.querySelector('.kaching-bundles__bar-price');
    // const fullPrice = selector.querySelector('.kaching-bundles__bar-full-price');

    // cleanupAppendedPrice(discountPrice);
    // cleanupAppendedPrice(fullPrice);

    const discountFormated = shopifyFormatMoney(Math.ceil(discountedTotal / quantity), shopifyFormat);
    const fullPriceFormated = shopifyFormatMoney(Math.ceil(fullTotal / quantity), shopifyFormat);

    // appendPrice(discountPrice, discountFormated, true);
    // appendPrice(fullPrice, fullPriceFormated, false);

    if (selectedDealBarId === dealBar.id) {
      pricing.discountedPrice.amount = Math.ceil(discountedTotal / quantity);
      pricing.discountedPrice.formatted = discountFormated;
      pricing.fullPrice.amount = Math.ceil(fullTotal / quantity);
      pricing.fullPrice.formatted = fullPriceFormated;
    }
  });

  changeManualPrice({
    target: block,
    detail: {
      pricing: pricing,
    },
  });
}

function updateBlockPrice(event) {
  const {
    pricing: { discountedPrice, fullPrice, discountedPricePerItem, fullPricePerItem },
    variantIdQuantities,
  } = event.detail;

  const activeBar = event.target.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');
  if (!activeBar) return;
  const quantity = variantIdQuantities.map((variant) => variant.quantity).reduce((a, b) => a + b, 0) || 1;
  const discountedPricePerItemAmount =
    discountedPricePerItem?.amount ?? (discountedPrice?.amount ? Math.ceil(discountedPrice.amount / quantity) : null);
  const fullPricePerItemAmount =
    fullPricePerItem?.amount ?? (fullPrice?.amount ? Math.ceil(fullPrice.amount / quantity) : null);

  const shopifyFormat = themeVariables.settings.moneyFormatString;
  const shopifyFormatMoney = themeVariables.utils.money;

  const priceDiscount = activeBar.querySelector('.kaching-bundles__bar-price');
  const priceFull = activeBar.querySelector('.kaching-bundles__bar-full-price');

  const priceDiscountAppend = priceDiscount?.querySelector('span.price-append');
  const priceFullAppend = priceFull?.querySelector('span.price-append');

  if (priceDiscountAppend) priceDiscountAppend.remove();
  if (priceFullAppend) priceFullAppend.remove();

  if (discountedPricePerItemAmount != null) {
    appendPrice(priceDiscount, shopifyFormatMoney(discountedPricePerItemAmount, shopifyFormat), true);
  }

  if (fullPricePerItemAmount != null) {
    appendPrice(priceFull, shopifyFormatMoney(fullPricePerItemAmount, shopifyFormat), false);
  }
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function removeOptions() {  
  if ([78853505371, 115074859355].includes(themeVariables.market.id)) {
      const options = document.querySelectorAll('option[value="Yes. 2025-26 shirt"]');
      options.forEach( option => {
        const select = option.closest('select');
        option.remove();
        const countOptions = [...select.querySelectorAll('option')]
          .filter(option => option.value).length;
        select.toggleAttribute('hidden', countOptions <= 1);
      });
  }
}

window.addEventListener('kaching-bundles-initialized', async function () {
  await delay(250);
  removeOptions();

  const hasInner = !!document.querySelector('.kaching-bundle__inner');
  if (hasInner) document.addEventListener('click', interceptForceSubmitClick, true);

  document.querySelectorAll('kaching-bundles-block').forEach((element) => {
    if (hasInner) element.addEventListener('deal-bar-selected', checkSelectedBar);

    element.addEventListener('variants-changed', (event) => {
      if (hasInner) handleVariantsChanged(event);
      // const activeBar = element.querySelector('.kaching-bundles__bar.kaching-bundles__bar--selected');
      // if (activeBar) updateBlockPrice(event);
    });

    element.addEventListener('items-changed', (event) => {
      const isSelectedApp = Boolean(event.target.selectedDealBarId);
      if (!isSelectedApp) return;

      const variantPicker = event.target.closest("[data-block-type='variant-picker']");
      if (!variantPicker) {
        console.error('[Kaching Bundles] deal-bar-selected: variant picker container was not found.');
        return;
      }

      const inputOneTime = variantPicker.querySelector('.subsription-widget__field--one-time input');
      const accordion = variantPicker.querySelector('.accordion-toggle-item');
      if (!inputOneTime || !accordion) {
        console.error('[Kaching Bundles] deal-bar-selected: required one-time input or accordion element is missing.');
        return;
      }

      if (event.target.selectedDealBarId) {
        accordion.removeAttribute('open');
        const label = inputOneTime.labels[0];
        if (label) {
          label.click();
        } else {
          inputOneTime.checked = true;
        }
      }
    });

    updateBlockPrices(element);

    if(window.innerWidth < 768) {
      const blockInputs = [...element.querySelectorAll('input')]
      const selectedBlockInputs = blockInputs.find(input => input.checked);

      blockInputs[0].nextElementSibling?.click()

      setTimeout(() => {
        selectedBlockInputs.nextElementSibling?.click()
      }, 0) 
    }

    removeOptions();
  });
});

window.addEventListener('DOMContentLoaded', () => {
  removeOptions();
})
